(() => {
  const uiLabels = JSON.parse(document.querySelector('#finxful-ui-labels')?.textContent || '{}');
  const labels = {
    puffer: uiLabels.puffer || 'Puffer wirken in Zellen und Körperflüssigkeiten',
    atmung: uiLabels.atmung || 'Die Lunge gibt Kohlendioxid ab',
    nieren: uiLabels.nieren || 'Die Nieren regulieren die Säureausscheidung',
  };
  document.querySelectorAll('[data-anatomy]').forEach(section => {
    const tabs = [...section.querySelectorAll('[role="tab"]')];
    const panels = [...section.querySelectorAll('[data-panel]')];
    const markers = [...section.querySelectorAll('.anatomy-marker')];
    const label = section.querySelector('[data-figure-label]');
    function select(key, moveFocus = false) {
      if (!Object.hasOwn(labels, key)) return;
      tabs.forEach(tab => {
        const active = tab.dataset.mechanism === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus();
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.panel !== key; });
      markers.forEach(marker => marker.setAttribute('aria-pressed', String(marker.dataset.mechanism === key)));
      label.textContent = labels[key];
      section.dataset.active = key;
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.mechanism));
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        select(tabs[target].dataset.mechanism, true);
      });
    });
    markers.forEach(marker => marker.addEventListener('click', () => select(marker.dataset.mechanism)));
    section.dataset.enhanced = '';
    section.querySelector('[data-mechanism-tabs]').hidden = false;
    section.querySelector('[data-anatomy-markers]').hidden = false;
    select('puffer');
  });
  const sources = document.querySelector('#quellen');
  function openSources() {
    if (sources && window.location.hash === '#quellen') sources.open = true;
  }
  document.querySelectorAll('a[href="#quellen"]').forEach(link => link.addEventListener('click', () => {
    if (sources) sources.open = true;
  }));
  window.addEventListener('hashchange', openSources);
  openSources();
})();
